
    import './styles.scoped.css';
    export default {
  "input-adorned-container": "awsui_input-adorned-container_2rhyz_q26o4_141",
  "input": "awsui_input_2rhyz_q26o4_141",
  "input-adorned-container-readonly": "awsui_input-adorned-container-readonly_2rhyz_q26o4_154",
  "input-readonly": "awsui_input-readonly_2rhyz_q26o4_154",
  "root": "awsui_root_2rhyz_q26o4_171",
  "input-invalid": "awsui_input-invalid_2rhyz_q26o4_274",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_q26o4_283",
  "input-warning": "awsui_input-warning_2rhyz_q26o4_286",
  "input-type-search": "awsui_input-type-search_2rhyz_q26o4_298",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_q26o4_311",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_q26o4_314",
  "input-container": "awsui_input-container_2rhyz_q26o4_321",
  "input-icon-start": "awsui_input-icon-start_2rhyz_q26o4_326",
  "input-icon-end": "awsui_input-icon-end_2rhyz_q26o4_333",
  "input-button-right": "awsui_input-button-right_2rhyz_q26o4_339",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_q26o4_343",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_q26o4_346",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_q26o4_350",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_q26o4_353",
  "inline-label": "awsui_inline-label_2rhyz_q26o4_343",
  "input-adorned-container-invalid": "awsui_input-adorned-container-invalid_2rhyz_q26o4_400",
  "input-adorned-container-warning": "awsui_input-adorned-container-warning_2rhyz_q26o4_415",
  "input-adorned-container-disabled": "awsui_input-adorned-container-disabled_2rhyz_q26o4_430",
  "input-prefix": "awsui_input-prefix_2rhyz_q26o4_439",
  "input-suffix": "awsui_input-suffix_2rhyz_q26o4_440",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_q26o4_453",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_q26o4_462",
  "input-adorned": "awsui_input-adorned_2rhyz_q26o4_141"
};
  